import { handleActions } from 'redux-actions';

import { AdvertiserReportsResponse } from '@ha/api/v2/types/surveyReviews/AdvertiserReports';
import { AdvertiserOverallRatingResponse } from '@ha/api/v2/types/surveyReviews/AdvertiserOverallRating';

import { Actions, LoadTenantReviewsDone } from '../constants';

export type State = Readonly<{
  reports: AdvertiserReportsResponse;
  overallRating: AdvertiserOverallRatingResponse;
}>;

export const initialState: State = {
  reports: {
    reports: [],
    count: 0,
  },
  overallRating: {
    overallRating: 0,
    moveInOverallRating: 0,
    moveOutOverallRating: 0,
    moveInReviewCount: 0,
    moveOutReviewCount: 0,
    reviewCount: 0,
    surveyTopics: {},
  },
};

const tenantReviewsReducer = handleActions(
  {
    [Actions.LOAD_TENANT_REVIEWS_OVERALL_DONE]: (
      state,
      action: LoadTenantReviewsDone,
    ) => ({
      ...state,
      overallRating: action.payload.overallRating ?? initialState.overallRating,
    }),
    [Actions.LOAD_TENANT_REVIEWS_REPORTS_DONE]: (
      state,
      action: LoadTenantReviewsDone,
    ) => ({
      ...state,
      reports: action.payload.reports ?? initialState.reports,
    }),
  },
  initialState,
);
export { tenantReviewsReducer };
